// extracted by mini-css-extract-plugin
module.exports = {"container":"ReceivedApplications_container__3vebS","info":"ReceivedApplications_info__3_m23","empty":"ReceivedApplications_empty__1iSMp","list":"ReceivedApplications_list__3jG0y"};